module.exports = __webpack_public_path__ + "img/拼团_规则.2dbe9637.png";